import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { setDefaultOfForm, emailPOPost } from '../../actions/purchaseOrders_actions';
import CustomerStatement from '../../components/AR/customerStatement';
import { fetchCustomerStatement } from '../../actions/arap_actions';
import { setValue, fetchSalesCustomerDetail } from '../../actions/sales_actions';
import { fetchCustomers } from '../../actions/customers_actions';
import { printARReport, printPlainARReport, printSalesInvoiceForCustomerStatement, printSalesInvoiceReturn } from '../../actions/print_actions';


const customerStatement = reduxForm({
  form: 'customerStatement',
})(CustomerStatement);

const selector = formValueSelector('customerStatement');

function mapStateToProps(state) {
    const typeRadios = selector(state, 'typeRadios');
    const Year = selector(state, 'Year');
    const Month = selector(state, 'Month');
    const StatementType = selector(state, 'StatementType');
    const Quarter = selector(state, 'Quarter');
    const FromDate = selector(state, 'FromDate');
    const ToDate = selector(state, 'ToDate');
    const Customer = selector(state, 'Customer');

    return {
        typeRadios,
        Year,
        Month,
        StatementType,
        Quarter,
        FromDate,
        ToDate,
        Customer,
        customerStatementIsLoading: state.arap.customerStatementIsLoading,
        customerStatement: state.arap.customerStatement,
        customerStatementError: state.arap.customerStatementError,
        customers: state.customers.all,
        customersIsLoading: state.customers.isLoading,
        customersError: state.customers.error,
        salesCustomerDetails: state.salesOrders.salesCustomerDetails,
        salesCustomerDetailsIsLoading: state.salesOrders.salesCustomerDetailsIsLoading,
        salesCustomerDetailsError: state.salesOrders.salesCustomerDetailsError,
        currentCustomer: state.customers.currentCustomer,

        requestingArReport: state.print.requestingArReport,
        arReport: state.print.arReport,
        selectedCompany: state.header.selectedCompany,
    };
}

export default connect(mapStateToProps, {
    setDefaultOfForm,
    fetchCustomerStatement,
    setValue,
    fetchCustomers,
    fetchSalesCustomerDetail,
    printARReport,
    emailPOPost,
    printPlainARReport,
    printSalesInvoiceForCustomerStatement,
    printSalesInvoiceReturn,
})(customerStatement);



// WEBPACK FOOTER //
// ./master/jsx/containers/AR/customerStatement.jsx